import React from 'react'
import { Link } from 'react-router-dom'

import { Row, Cell } from 'components/Table'

import 'react-popper-tooltip/dist/styles.css'
import { getPrintableTime } from 'lib/datetime'
import { ORDER_STATUS } from 'pages/operations/SaleOrders/Details/ReDelivery/constant'
import '../style.scss'

const SalesOrderTableView = () => {
  return {
    headers: [
      'Parent Sales Order ID',
      'Order Number',
      'Total Amount',
      'Total Payable Amount',
      'Status',
      'Date Created',
    ],
    row: ({
      id,
      baseSalesOrder,
      orderNo,
      totalAmount,
      totalPaymentAmount,
      state,
      createTime,
    }) => (
      <Row>
        <Cell className="sale-order-num">
          <Link to={`/customer-support/sale-orders/${baseSalesOrder?.id}`}>
            {baseSalesOrder?.id}
          </Link>
        </Cell>
        <Cell className="sale-order-num">
          <Link to={`/customer-support/sales-orders/${id}`}>{orderNo}</Link>
        </Cell>
        <Cell className="sale-order-num">{totalAmount}</Cell>
        <Cell className="sale-order-num">{totalPaymentAmount}</Cell>
        <Cell className="sale-order-num">{ORDER_STATUS[state]}</Cell>
        <Cell className="sale-order-num">
          {createTime ? getPrintableTime(createTime).split(', ')[0] : null}
        </Cell>
      </Row>
    ),
  }
}

export default SalesOrderTableView
